import { Action } from 'redux';

export const GET_ORDER = 'orders/GET_ORDER';
export interface GetOrderAction extends Action<typeof GET_ORDER> {
  readonly payload: {
    readonly id: number;
    readonly driverId?: number;
  };
}

export const PERSIST_ORDER = 'orders/PERSIST_ORDER';
export interface PersistOrderAction extends Action<typeof PERSIST_ORDER> {
  readonly payload: {
    readonly order: Order;
    readonly etag?: string;
  };
}

export const ADD_NOTE_TO_ORDER = 'orders/ADD_NOTE_TO_ORDER';
export interface AddNoteToOrderAction extends Action<typeof ADD_NOTE_TO_ORDER> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly orderId: number;
    readonly note: string;
  };
}

export const RESEND_ORDER_CONFRIMATION_EMAIL = 'orders/RESEND_ORDER_EMAIL';
export interface ResendOrderConfirmationEmailAction extends Action<typeof RESEND_ORDER_CONFRIMATION_EMAIL> {
  readonly meta: ActionMetaData;
  readonly payload: ResendOrderEmailRequest;
}

export const RESEND_ORDER_FULFILLMENT_EMAIL = 'orders/RESEND_ORDER_FULFILLMENT_EMAIL';
export interface ResendOrderFulfillmentEmailAction extends Action<typeof RESEND_ORDER_FULFILLMENT_EMAIL> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly fulfillmentId: number;
    readonly lineId: number;
    readonly email?: string;
    readonly note?: string;
  };
}

export const RESEND_ORDER_ATP_EMAIL = 'orders/RESEND_ORDER_ATP_EMAIL';
export interface ResendOrderATPEmailAction extends Action<typeof RESEND_ORDER_ATP_EMAIL> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly fulfillmentId: number;
    readonly lineId: number;
    readonly email?: string;
    readonly note?: string;
  };
}

export const CANCEL_ORDER = 'orders/CANCEL_ORDER';
export interface CancelOrderAction extends Action<typeof CANCEL_ORDER> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly orderId: number;
    readonly note?: string;
  };
}

export const PRINT_ORDER_RECEIPT = 'orders/PRINT_ORDER_RECEIPT';
export interface PrintOrderReceiptAction extends Action<typeof PRINT_ORDER_RECEIPT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly orderId: number;
  };
}

export const PRINT_ORDER_FULFILLMENT_LETTER = 'orders/PRINT_ORDER_FULFILLMENT_LETTER';
export interface PrintOrderFulfillmentLetterAction extends Action<typeof PRINT_ORDER_FULFILLMENT_LETTER> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly lineId: number;
  };
}

export const PRINT_ORDER_VIRTUAL_PERMIT = 'orders/PRINT_ORDER_VIRTUAL_PERMIT';
export interface PrintOrderVirtualPermitAction extends Action<typeof PRINT_ORDER_VIRTUAL_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly lineId: number;
  };
}

export const PRINT_ORDER_TEMPORARY_PERMIT = 'orders/PRINT_ORDER_TEMPORARY_PERMIT';
export interface PrintOrderTemporaryPermitAction extends Action<typeof PRINT_ORDER_TEMPORARY_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly lineId: number;
  };
}
// download-tp
export const PRINT_TP_ORDER_TEMPORARY_PERMIT = 'orders/PRINT_TP_ORDER_TEMPORARY_PERMIT';
export interface PrintOrderTpTemporaryPermitAction extends Action<typeof PRINT_TP_ORDER_TEMPORARY_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly lineId: number;
  };
}

export const ASSOCIATE_ORDER_VEHICLES = 'orders/ASSOCIATE_ORDER_VEHICLES';
export interface AssociateOrderVehiclesAction extends Action<typeof ASSOCIATE_ORDER_VEHICLES> {
  readonly meta: ActionMetaData;
  readonly payload: OrderFulfillmentVehicles;
}

export const ADD_ORDER_PAYMENT = 'orders/ADD_ORDER_PAYMENT';
export interface AddOrderPaymentAction extends Action<typeof ADD_ORDER_PAYMENT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly orderId: number;
    readonly payment: OrderPaymentFormValues;
  };
}

export const REVERSE_ORDER_PAYMENT = 'orders/REVERSE_ORDER_PAYMENT';
export interface ReverseOrderPaymentAction extends Action<typeof REVERSE_ORDER_PAYMENT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly orderId: number;
  };
}

export const ADJUST_ORDER_PAYMENT = 'orders/ADJUST_ORDER_PAYMENT';
export interface AdjustOrderPaymentAction extends Action<typeof ADJUST_ORDER_PAYMENT> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly orderId: number;
    readonly payment: OrderPaymentFormValues;
  };
}

export const GET_AVAILABLE_FULFILLMENT_ITEMS = 'orders/GET_AVAILABLE_FULFILLMENT_ITEMS';
export interface GetAvailableFulfillmentItemsAction extends Action<typeof GET_AVAILABLE_FULFILLMENT_ITEMS> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly fulfillmentId: number;
  };
}

export const PERSIST_AVAILABLE_FULFILLMENT_ITEMS = 'orders/PERSIST_AVAILABLE_FULFILLMENT_ITEMS';
export interface PersistAvailableFulfillmentItemsAction extends Action<typeof PERSIST_AVAILABLE_FULFILLMENT_ITEMS> {
  readonly payload: {
    readonly items: ReadonlyArray<InventoryBucketItem>;
  };
}

export const ORDER_SUSPEND_PERMIT = 'orders/ORDER_SUSPEND_PERMIT';
export interface OrderSuspendPermitAction extends Action<typeof ORDER_SUSPEND_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: FulfillmentActionRequest;
}

export const ORDER_ACTIVATE_PERMIT = 'orders/ORDER_ACTIVATE_PERMIT';
export interface OrderActivatePermitAction extends Action<typeof ORDER_ACTIVATE_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: FulfillmentActionRequest;
}

export const ORDER_ASSIGN_PERMIT = 'orders/ORDER_ASSIGN_PERMIT';
export interface OrderAssignPermitAction extends Action<typeof ORDER_ASSIGN_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: FulfillmentAssignmentRequest;
}

export const ORDER_REVOKE_PERMIT = 'orders/ORDER_REVOKE_PERMIT';
export interface OrderRevokePermitAction extends Action<typeof ORDER_REVOKE_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: RevokePermitRequest;
}

export const RE_ASSIGN_PERMIT = 'orders/RE_ASSIGN_PERMIT';
export interface OrderReAssionPermitAction extends Action<typeof RE_ASSIGN_PERMIT> {
  readonly meta: ActionMetaData;
  readonly payload: ReAssignPermitRequest;
}

export type OrderAction =
  | GetOrderAction
  | PersistOrderAction
  | AddNoteToOrderAction
  | ResendOrderConfirmationEmailAction
  | ResendOrderFulfillmentEmailAction
  | ResendOrderATPEmailAction
  | CancelOrderAction
  | PrintOrderReceiptAction
  | PrintOrderFulfillmentLetterAction
  | PrintOrderVirtualPermitAction
  | PrintOrderTemporaryPermitAction
  | AssociateOrderVehiclesAction
  | AddOrderPaymentAction
  | ReverseOrderPaymentAction
  | AdjustOrderPaymentAction
  | GetAvailableFulfillmentItemsAction
  | PersistAvailableFulfillmentItemsAction
  | OrderSuspendPermitAction
  | OrderActivatePermitAction
  | OrderAssignPermitAction
  | SetInventoryBucketAction
  | SetInventorySerialNoAction
  | OrderRevokePermitAction;

export const assignOrderPermit = (
  data: FulfillmentAssignmentRequest,
  meta: ActionMetaData = {},
): OrderAssignPermitAction => ({
  meta,
  payload: data,
  type: ORDER_ASSIGN_PERMIT,
});

export const activateOrderPermit = (
  data: FulfillmentActionRequest,
  meta: ActionMetaData = {},
): OrderActivatePermitAction => ({
  meta,
  payload: data,
  type: ORDER_ACTIVATE_PERMIT,
});

export const suspendOrderPermit = (
  data: FulfillmentActionRequest,
  meta: ActionMetaData = {},
): OrderSuspendPermitAction => ({
  meta,
  payload: data,
  type: ORDER_SUSPEND_PERMIT,
});

export const revokeOrderPermit = (data: RevokePermitRequest, meta: ActionMetaData = {}): OrderRevokePermitAction => ({
  meta,
  payload: data,
  type: ORDER_REVOKE_PERMIT,
});

export const ReAssignOrderPermit = (
  data: ReAssignPermitRequest,
  meta: ActionMetaData = {},
): OrderReAssionPermitAction => ({
  meta,
  payload: data,
  type: RE_ASSIGN_PERMIT,
});

export const getAvailableFulfillmentItems = (
  fulfillmentId: number,
  meta: ActionMetaData = {},
): GetAvailableFulfillmentItemsAction => ({
  meta,
  payload: {
    fulfillmentId,
  },
  type: GET_AVAILABLE_FULFILLMENT_ITEMS,
});

export const persistAvailableFulfillmentItems = (
  items: ReadonlyArray<InventoryBucketItem>,
): PersistAvailableFulfillmentItemsAction => ({
  payload: {
    items,
  },
  type: PERSIST_AVAILABLE_FULFILLMENT_ITEMS,
});

export const adjustOrderPayment = (
  order: Order,
  payment: OrderPaymentFormValues,
  meta: ActionMetaData = {},
): AdjustOrderPaymentAction => ({
  meta,
  payload: {
    orderId: order.id!,
    payment,
  },
  type: ADJUST_ORDER_PAYMENT,
});

export const reverseOrderPayment = (order: Order, meta: ActionMetaData = {}): ReverseOrderPaymentAction => ({
  meta,
  payload: {
    orderId: order.id!,
  },
  type: REVERSE_ORDER_PAYMENT,
});

export const addOrderPayment = (
  order: Order,
  payment: OrderPaymentFormValues,
  meta: ActionMetaData = {},
): AddOrderPaymentAction => ({
  meta,
  payload: {
    orderId: order.id!,
    payment,
  },
  type: ADD_ORDER_PAYMENT,
});

export const associateOrderVehicles = (
  data: OrderFulfillmentVehicles,
  meta: ActionMetaData = {},
): AssociateOrderVehiclesAction => ({
  meta,
  payload: data,
  type: ASSOCIATE_ORDER_VEHICLES,
});

export const printOrderReceipt = (orderId: number, meta: ActionMetaData = {}): PrintOrderReceiptAction => ({
  meta,
  payload: {
    orderId,
  },
  type: PRINT_ORDER_RECEIPT,
});

export const printOrderFulfillmentLetter = (
  lineId: number,
  meta: ActionMetaData = {},
): PrintOrderFulfillmentLetterAction => ({
  meta,
  payload: {
    lineId,
  },
  type: PRINT_ORDER_FULFILLMENT_LETTER,
});

export const printOrderVirtualPermit = (lineId: number, meta: ActionMetaData = {}): PrintOrderVirtualPermitAction => ({
  meta,
  payload: {
    lineId,
  },
  type: PRINT_ORDER_VIRTUAL_PERMIT,
});

export const printOrderTemporaryPermit = (
  lineId: number,
  meta: ActionMetaData = {},
): PrintOrderTemporaryPermitAction => ({
  meta,
  payload: {
    lineId,
  },
  type: PRINT_ORDER_TEMPORARY_PERMIT,
});
//  download-tp permit
export const printTpOrderTemporaryPermit = (
  lineId: number,
  meta: ActionMetaData = {},
): PrintOrderTpTemporaryPermitAction => ({
  meta,
  payload: {
    lineId,
  },
  type: PRINT_TP_ORDER_TEMPORARY_PERMIT,
});
//  download-tp permit end

export const getOrder = (id: number, driverId?: number): GetOrderAction => ({
  payload: {
    driverId,
    id,
  },
  type: GET_ORDER,
});

export const persistOrder = ({
  order,
  etag,
}: {
  readonly order: Order;
  readonly etag?: string;
}): PersistOrderAction => ({
  payload: {
    etag,
    order,
  },
  type: PERSIST_ORDER,
});

export const addNoteToOrder = (orderId: number, note: string, meta: ActionMetaData = {}): AddNoteToOrderAction => ({
  meta,
  payload: {
    note,
    orderId,
  },
  type: ADD_NOTE_TO_ORDER,
});

export const resendOrderConfirmationEmail = (
  data: ResendOrderEmailRequest,
  meta: ActionMetaData = {},
): ResendOrderConfirmationEmailAction => ({
  meta,
  payload: data,
  type: RESEND_ORDER_CONFRIMATION_EMAIL,
});

export const resendOrderFulfillmentEmail = (
  data: ResendOrderFulfillmentEmailAction['payload'],
  meta: ActionMetaData = {},
): ResendOrderFulfillmentEmailAction => ({
  meta,
  payload: data,
  type: RESEND_ORDER_FULFILLMENT_EMAIL,
});

export const resendOrderATPEmail = (
  data: ResendOrderATPEmailAction['payload'],
  meta: ActionMetaData = {},
): ResendOrderATPEmailAction => ({
  meta,
  payload: data,
  type: RESEND_ORDER_ATP_EMAIL,
});

export const cancelOrder = (
  data: { readonly orderId: number; readonly note?: string },
  meta: ActionMetaData = {},
): CancelOrderAction => ({
  meta,
  payload: data,
  type: CANCEL_ORDER,
});

// Create Action Delete Order

export const CLIENT_ADMIN_DELETE_ORDER = 'orders/CLIENT_ADMIN_DELETE_ORDER';

export const clientAdminDeleteOrder = (data: any) => {
  return {
    type: CLIENT_ADMIN_DELETE_ORDER,
    payload: data,
  };
};

export const GET_INVENTORY_BUCKET_PERMIT = 'orders/GET_INVENTORY_BUCKET_PERMIT';
export const getInventoryBucketPermit = (data: any) => {
  return {
    type: GET_INVENTORY_BUCKET_PERMIT,
    payload: data,
  };
};
export const SET_INVENTORY_BUCKET_PERMIT = 'orders/SET_INVENTORY_BUCKET_PERMIT';
export const setInventoryBucketPermit = (data: any) => {
  return {
    type: SET_INVENTORY_BUCKET_PERMIT,
    payload: data,
  };
};

export interface SetInventoryBucketAction extends Action<typeof SET_INVENTORY_BUCKET_PERMIT> {
  readonly payload: ReadonlyArray<any>;
}
// get inventory serial no
export const GET_INVENTORY_SERIAL_NO = 'orders/GET_INVENTORY_SERIAL_NO';
export const getInventorySerialNo = (data: any) => {
  return {
    type: GET_INVENTORY_SERIAL_NO,
    payload: data,
  };
};
export const SET_INVENTORY_SERIAL_NO = 'orders/SET_INVENTORY_SERIAL_NO';
export const setInventorySerialNo = (data: any) => {
  return {
    type: SET_INVENTORY_SERIAL_NO,
    payload: data,
  };
};

export interface SetInventorySerialNoAction extends Action<typeof SET_INVENTORY_SERIAL_NO> {
  readonly payload: ReadonlyArray<any>;
}
